/**
 * Shared V2 shell for Camp Recipes sub-pages.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaChevronLeft, FaUtensils } from 'react-icons/fa';
import './camp-essentials-shell.css';
import './camp-recipes-shell.css';

export function CommunityRecipesPageShell({
  backLabel = 'Recipes',
  backTo = '/camp-essentials/recipes',
  title,
  subtitle = 'Wild game recipes',
  panelClassName = '',
  testId,
  children,
}) {
  const navigate = useNavigate();

  return (
    <div className="camp-essentials-shell camp-recipes-page" data-testid={testId}>
      <svg className="camp-essentials-shell__bg-grid" aria-hidden="true">
        <defs>
          <pattern
            id="camp-recipes-page-grid"
            width="40"
            height="40"
            patternUnits="userSpaceOnUse"
          >
            <path d="M 40 0 L 0 0 0 40" fill="none" stroke="currentColor" strokeWidth="1" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#camp-recipes-page-grid)" />
      </svg>

      <div className="camp-essentials-shell__inner camp-recipes-page__inner">
        <button
          type="button"
          className="camp-essentials-gear__back"
          onClick={() => navigate(backTo)}
        >
          <FaChevronLeft size={12} aria-hidden="true" />
          {backLabel}
        </button>

        <header className="camp-recipes-page__header">
          <div className="camp-essentials-shell__header-main">
            <div className="camp-essentials-shell__header-icon" aria-hidden="true">
              <FaUtensils size={18} />
            </div>
            <div>
              <h1 className="camp-essentials-shell__title">{title}</h1>
              {subtitle ? <p className="camp-essentials-shell__subtitle">{subtitle}</p> : null}
            </div>
          </div>
        </header>

        <div
          className={['camp-recipes-page__panel', panelClassName].filter(Boolean).join(' ')}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
